import type { PurchaseSnapshot } from '~/services/purchaseRecovery';
import { mainStore } from '~/stores';

import { analyticsService } from './AnalyticsService';
import { AnalyticsEvent } from './events';
import { trackTikTokFirstPurchase } from './tiktokPurchase';

export const trackPurchase = (snapshot: PurchaseSnapshot): void => {
  const currency = snapshot.currency.toUpperCase();

  mainStore.sendToRN('sendTags', {
    last_ordered_time: Math.floor(Date.now() / 1000),
  });

  analyticsService.track(AnalyticsEvent.PIXEL_PURCHASE, {
    value: mainStore.toFloat(snapshot.finalPrice),
    currency,
    content_type: 'product',
    num_items: snapshot.itemsAmount,
    order_id: snapshot.orderId,
  });

  analyticsService.track(AnalyticsEvent.PURCHASE_COMPLETED, {
    cart_id: undefined,
    products_amount: snapshot.productsAmount,
    items_amount: snapshot.itemsAmount,
    price: snapshot.basePrice,
    final_price: snapshot.finalPrice,
    eta_min: snapshot.etaMin,
    eta_max: snapshot.etaMax,
    delivery_fee: snapshot.deliveryFee,
    threshold: snapshot.threshold,
    is_surger: snapshot.isSurger,
    order_id: snapshot.orderId,
    order_num: snapshot.orderNum,
    promocode: snapshot.promocode,
    warehouse_code: snapshot.warehouseCode,
  });

  if (snapshot.isFirstPurchase) {
    analyticsService.track(AnalyticsEvent.AF_FIRST_PURCHASE, {
      revenue: snapshot.finalPrice,
      price: snapshot.basePrice,
      quantity: snapshot.itemsAmount,
      currency,
      order_id: snapshot.orderId,
    });
    analyticsService.track(AnalyticsEvent.FIRST_PURCHASE, {
      transaction_id: snapshot.orderId,
      value: mainStore.toFloat(snapshot.finalPrice),
      currency,
      tax: 0,
      shipping: 0,
      items: snapshot.items,
      coupon: snapshot.promocode,
    });
    mainStore.sendToRN('trackOneSignalOutcome', {
      name: 'first_purchase_quantity',
      value: snapshot.itemsAmount,
    });
    mainStore.sendToRN('trackOneSignalOutcome', {
      name: 'first_purchase_amount',
      value: snapshot.basePrice,
    });
    void trackTikTokFirstPurchase(snapshot);
  } else {
    mainStore.sendToRN('trackOneSignalOutcome', {
      name: 'purchase_quantity',
      value: snapshot.itemsAmount,
    });
    mainStore.sendToRN('trackOneSignalOutcome', {
      name: 'purchase_amount',
      value: snapshot.basePrice,
    });
  }

  mainStore.sendToRN('setUserProperties', {
    'Commerce: last purchase date': new Date().toISOString(),
  });
  mainStore.sendToRN('setUserProperties', {
    'Commerce: last order eta': snapshot.etaMin,
  });

  analyticsService.track(AnalyticsEvent.PURCHASE, {
    transaction_id: snapshot.orderId,
    value: mainStore.toFloat(snapshot.finalPrice),
    currency,
    tax: 0,
    shipping: 0,
    items: snapshot.items,
    coupon: snapshot.promocode,
  });

  snapshot.deliveryInstructions.forEach((instruction) => {
    analyticsService.track(AnalyticsEvent.DELIVERY_INSTRUCTIONS, {
      deliveryInstruction: instruction,
    });
  });
};
